<!--  -->
<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="Overview" name="first">
        <v-overview :nodeId="nodeId" @updateMarkers="updateMarkers"></v-overview>
    </el-tab-pane>
    <el-tab-pane label="Gallery" name="second">
        <v-gallery :nodeId="nodeId" :gallery="gallery"></v-gallery>
    </el-tab-pane>
    <el-tab-pane label="Specimens" name="third">
      <span slot="label">Specimens<el-badge :value="totalCount"></el-badge></span>
      <v-specimen :nodeId="nodeId" :totalCount="totalCount" @getTotalCount="getTotalCount" :points="points" @updateGallery="updateGallery"></v-specimen>
    </el-tab-pane>

  </el-tabs>
</template>

<script>
import VSpecimen from "./specimen.vue";
import VOverview from "./overview.vue";
import VGallery from "./gallery.vue";
export default {
  name: "specimen",
  props:['nodeId'],
  components: {
    VSpecimen,
    VOverview,
    VGallery,
  },
  data() {
    return {
      totalCount: 0,
      activeName: "first",
      points:[],
      gallery:[]
    //   markers:[]
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    //   console.log(this.nodeId)
  },
  methods: {
    updateMarkers(points){
        this.$set(this,'points',points)
    },
    updateGallery(data){
        this.$set(this,'gallery',data);
    },
    handleClick(tab, event) {
        // console.log(this.nodeId);
        //根据nodeid获取数据
    },
    // getMarkers(markers) {
    //     console.log('getmarkers',markers);
    //     this.$set(this,'markers',markers);
    // },
    getTotalCount(value) {
        this.totalCount = value;
    }
  },
};
</script>
<style>
.el-tabs--card > .el-tabs__header .el-tabs__item {
  position: relative;
}
.el-tabs__item {
  height: 52px;
  line-height: 52px;
}
.el-tabs__item:hover{
    color: #72c2c9;
}
.el-tabs__item.is-active{
    color: #484D63;
}
.el-tabs__nav{
    width: 100%;
}
.el-tabs--card > .el-tabs__header .el-tabs__item {
  border-left: none;
}
.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
  margin-bottom: -2px;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border: 2px solid #efefef;
  border-radius: 4px 4px 0 0;
  border-bottom-color: white;
  position: relative;
}
.el-tabs--card
  > .el-tabs__header
  .el-tabs__item.is-active
  + .el-tabs__item:hover::before,
.el-tabs--card
  > .el-tabs__header
  .el-tabs__item.is-active
  + .el-tabs__item::before {
  border-left: 2px solid #efefef;
  border-radius: 4px 0 0 4px;
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active::after {
  content: "";
  position: absolute;
  left: -2px;
  bottom: -2px;
  width: calc(100% + 4px);
  height: 2px;
  background: transparent;
  z-index: 99;
}
.el-tabs__nav-wrap{
    margin-bottom: -2px;
}
/* .el-tabs--card > .el-tabs__header .el-tabs__item.is-active::after {
  content: "";
  position: absolute;
  right: -2px;
  bottom: -2px;
  border-bottom: 2px solid #efefef;
  border-right: 2px solid #efefef;
  border-radius: 0 0 0 100%;

}
.el-tabs--card > .el-tabs__header .el-tabs__item:first-child.is-active::before {
}
.el-tabs--card > .el-tabs__header .el-tabs__item.is-active::before {
  content: "";
  position: absolute;
  left: -2px;
  bottom: -2px;
  border-bottom: 2px solid #efefef;
  border-left: 2px solid #efefef;
  border-radius: 0 0 100% 0;
} */
.el-badge__content {
  height: 27px;
  line-height: 25px;
  background: #72c2c9;
  border-radius: 50px;
  margin-left: 8px;
}
.el-tabs--card>.el-tabs__header{
    /* border-bottom: 2px solid #efefef; */
    border-bottom: 2px solid #efefef;
}
/* .el-tabs--card>.el-tabs__header .el-tabs__item{
    border-width: 2px;
}
.el-tabs--card>.el-tabs__header{
    border-width: 2px;
} */
</style>
